export function updateSources (element: HTMLVideoElement & {hls: any; cleanupHls: (from?: string) => void}, sources: { src: string; type: string }[], frame='') {
  const Hls = (window as any)['Hls']
  const source = sources[0]

  const cleanupHls = (from?: string) => {
    if (element.hls) {
      try {
        element.hls.stopLoad();
        element.hls.destroy();
      } catch (e) {
        console.warn('Error during HLS cleanup:', e);
      } finally {
        element.hls = null;
        // Force garbage collection hint
        if ('gc' in window) {
          try {
            (window as any).gc();
          } catch (e) {}
        }
      }
    }
  };

  element.cleanupHls = cleanupHls;

  if (source.type === 'application/x-mpegURL' && Hls.isSupported()) {
    try {
      // Clean up existing HLS instance
      cleanupHls('init');

      // Create new HLS instance with optimized config for mobile Chrome
      const hls = new Hls({});

      // Add error event handlers
      hls.on(Hls.Events.ERROR, (event: any, data: any) => {
        if (data.fatal) {
          switch (data.type) {
            case Hls.ErrorTypes.NETWORK_ERROR:
              console.warn('Fatal network error encountered, trying to recover');
              hls.startLoad();
              break;
            case Hls.ErrorTypes.MEDIA_ERROR:
              console.warn('Fatal media error encountered, trying to recover');
              hls.recoverMediaError();
              break;
            default:
              console.error('Fatal error, cannot recover:', data);
              cleanupHls('error');
              fallbackToRegularSource();
              break;
          }
        }
      });



      hls.loadSource(source.src);
      hls.attachMedia(element);
      element.hls = hls;
    } catch (error) {
      console.error('HLS initialization failed:', error);
      cleanupHls('init-failed');
      fallbackToRegularSource();
    }
  } else {
    fallbackToRegularSource();
  }

  function fallbackToRegularSource() {
    const sourceElements = Array.from(element.querySelectorAll('source'));
    
    // Remove existing sources
    sourceElements.forEach(source => source.remove());
    
    // Add new sources
    for (const source of sources) {
      const newElement = document.createElement('source');
      newElement.src = `${source.src}${frame}`;
      newElement.setAttribute('type', source.type);
      element.appendChild(newElement);
    }
    
    // Enhanced error handling for regular video
    const errorHandler = () => {
      console.error('Video loading failed:', element.error);
      // Try to load next source if available
      const currentSource = element.currentSrc;
      const nextSource = sources.find(s => `${s.src}${frame}` !== currentSource);
      if (nextSource) {
        element.src = `${nextSource.src}${frame}`;
        element.load();
      }
    };

    // Remove existing error handler before adding new one
    element.removeEventListener('error', errorHandler);
    element.addEventListener('error', errorHandler);

    element.load();
  }

  // Return cleanup function for component unmounting
  return (from?: string) => {
    cleanupHls(from || 'unmount');
  };
}